/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungserstellAntragDto } from '../../models/buchungserstell-antrag-dto';

export interface GetGleittagAntraegeForMitarbeiter$Plain$Params {

/**
 * ID des Mitarbeiters, für den die Gleittag-Anträge geholt werden sollen
 */
  mitarbeiterId: string;
}

export function getGleittagAntraegeForMitarbeiter$Plain(http: HttpClient, rootUrl: string, params: GetGleittagAntraegeForMitarbeiter$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungserstellAntragDto>>> {
  const rb = new RequestBuilder(rootUrl, getGleittagAntraegeForMitarbeiter$Plain.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungserstellAntragDto>>;
    })
  );
}

getGleittagAntraegeForMitarbeiter$Plain.PATH = '/v1/mitarbeiter/{mitarbeiterId}/gleittagAntraege';
